import React, { Fragment, useMemo } from "react";
import Draggable from "react-draggable";
import { Button, Card, Link, Icon, TextArea } from "../../common/UIComponents";
import CopyableContent from "../common/CopyableContent";
import { isEmpty } from "lodash";
import { CloseIcon } from "../../common/CustomIcon";
import { base64ToPdf } from "../../common/Common";

const StickyNote = ({ info = {}, onClose, position, title }) => {
  const cardStyle = {
    position: "fixed",
    height: "430px",
    width: "400px",
    zIndex: 999,
  };

  const copyJSONToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  const memoizedJSON = useMemo(() => JSON.stringify(info.response, null, 2), [info.response]);
  const defaultPosition = position ? position : { x: 0, y: 0 }

 



  return (
    <Draggable handle=".ant-card-head"
      //  defaultPosition={
      //   position && !isEmpty(position.x) && !isEmpty(position.y) ? position : { x: 0, y: 0 }
      // } 
      defaultPosition={defaultPosition}
      position={null}>
      <Card
        className="sticky-note-card"
        size="small"
        style={cardStyle}
        title={
          <Fragment>
            <Icon type="menu" />
            &nbsp;&nbsp;{title}
          </Fragment>
        }
        extra={<CloseIcon onClick={onClose} />}
        bodyStyle={{
          height: "480px",
          overflowX: "auto",
          overflowY: "auto",
          margin: "10px"
        }}
      >
        {info?.note &&
          <div style={{ fontSize: "14px", fontWeight: "400", }}>

            {info.note}
          </div>
        }
        <div className="sticky-note-content">

          {info?.file_url && (
            <a href={info?.file_url}
              target="_blank"
              style={{ color: '#1890ff' }}
            >
              {info?.response?.filename ? info.response?.filename : 'File'}
            </a>
          )}


          {info?.response && (
            <div style={{paddingTop:"10px"}}>
              <TextArea style={{border:"none", outline:"none",boxShadow: "none"}} value={memoizedJSON} rows={15} />
            </div>
          )}
        </div>
      </Card>
    </Draggable>
  );
};

export default StickyNote;
